import { render, staticRenderFns } from "./repages.vue?vue&type=template&id=553a909f&scoped=true&"
import script from "./repages.vue?vue&type=script&lang=js&"
export * from "./repages.vue?vue&type=script&lang=js&"
import style0 from "./repages.vue?vue&type=style&index=0&id=553a909f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a909f",
  null
  
)

export default component.exports